import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  ViberShareButton,
  EmailShareButton,
} from 'react-share';
import {
  FacebookIcon,
  TelegramIcon,
  WhatsappIcon,
  LinkedinIcon,
  ViberIcon,
  EmailIcon,
} from 'react-share';

export default class Share extends Component {
  shareUrl = 'http://valferov.me';
  basicTitle = 'Check Vladimir, he may be a good fit for your backend developer position!';
  basicBody =
    "Hello, I've come across Vladimir's portfolio website and got an idea that he could be a good fit for your company. Here is a link to his CV website:";
  render() {
    return (
      <Row className="portfolio--share">
        <Col>
          <h3 className="portfolio--share__heading">referrals</h3>
          <div className="portfolio--share__referrals">
            <div>
              Know someone who is looking for a backend developer? Refer me to them! Thanks in
              advance ;-)
            </div>
            <Row>
              <Col>
                <LinkedinShareButton
                  children={
                    <Button variant="link">
                      <LinkedinIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                />
              </Col>
              <Col>
                <FacebookShareButton
                  children={
                    <Button variant="link">
                      <FacebookIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                  quote={this.basicTitle}
                />
              </Col>
              <Col>
                {' '}
                <TelegramShareButton
                  children={
                    <Button variant="link">
                      <TelegramIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                  title={this.basicTitle}
                />
              </Col>
              <Col>
                {' '}
                <WhatsappShareButton
                  children={
                    <Button variant="link">
                      <WhatsappIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                  title={this.basicTitle}
                />
              </Col>
              <Col>
                {' '}
                <ViberShareButton
                  children={
                    <Button variant="link">
                      <ViberIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                  title={this.basicTitle}
                />
              </Col>
              <Col>
                <EmailShareButton
                  children={
                    <Button variant="link">
                      <EmailIcon />
                    </Button>
                  }
                  url={this.shareUrl}
                  subject={this.basicTitle}
                  body={this.basicBody}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }
}
